import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAXE26mbf-0GNzEllTEFOs7pEGS-2jocnw",
  authDomain: "kbr-life-care--hospitals.firebaseapp.com",
  projectId: "kbr-life-care--hospitals",
  storageBucket: "kbr-life-care--hospitals.firebasestorage.app",
  messagingSenderId: "32013171785",
  appId: "1:32013171785:web:784af0f9f373645bcf5398",
  measurementId: "G-6P62ZJLBZW"
};

// Initialize Firebase only if no app exists
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app;